import { makePath } from "@admin/utils/makePath";
import React from "react";
import { ActionType, useProductMedia, useProductMediaDispatch } from "./FilesContext";
import { FileModel } from "@admin/domain/files/model/FileModel";
import FilePreview from "./FilePreview";
import ShowFileLink from "./ShowFileLink";
import { readableFileSize } from "@admin/utils/formatters";

type Props = {
    file: FileModel;
    mediaId: number | string;
    forMobileApp?: boolean;
    mediaIndex: number;
};

export default function FileInfo({ file, mediaId, forMobileApp, mediaIndex }: Props) {
    const dispatch = useProductMediaDispatch();
    const productMedia = useProductMedia();

    return (
        <div className="card border mb-4 position-relative">
            <div className="card-body">
                {forMobileApp && <h3>Вариант для МП</h3>}
                <div className="d-flex">
                    {!file.preview_file && (
                        <img className="me-3 img-thumbnail product_list_img" src={makePath(file.path)} alt="image" />
                    )}
                    <div className="d-flex flex-column justify-content-center">
                        <div>
                            <span className="fw-bolder">Название файла: </span>
                            {` `}
                            {file.name}
                        </div>
                        <div>
                            <span className="fw-bolder">Формат файла: </span>
                            {` `}
                            {file.mime}
                        </div>
                        <div>
                            <span className="fw-bolder">Размер файла: </span>
                            {` `}
                            {readableFileSize(file.metadata.size)}
                        </div>
                        <ShowFileLink file={file} />
                        <input
                            type="hidden"
                            name={`product_attributes[files][${mediaIndex}][${forMobileApp ? `mobile_app_file_id` : `file_id`}]`}
                            defaultValue={file.id}
                        />
                    </div>
                </div>

                {file.preview_file && <FilePreview preview={file.preview_file} />}
            </div>
            <i
                className="bi bi-x-circle position-absolute text-danger end-0 mt-5 me-5 cursor-pointer"
                onClick={(): void => {
                    if (mediaIndex === 0 && productMedia[1]?.file?.mime?.startsWith(`video`)) {
                        alert(`Видео не может быть находиться первым в списке медиа-файлов`);
                        return;
                    }

                    dispatch({
                        type: forMobileApp ? ActionType.DeleteMobileAppFile : ActionType.DeleteFile,
                        mediaId,
                    });
                }}
            />
        </div>
    );
}
